<template>

  <v-dialog v-model="open" max-width="290" dark>
    <!-- Modal Card -->
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text class="center">{{ message }}</v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="open = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  watch: {
    open(value) {
      if (value == false)
        this.$store.commit("dialogModal/toggleNotif");
    },
    storeOpen(value) {
      this.open = value;
    }
  },
  computed: {
    storeOpen: {
      get() {
        let open = this.$store.getters['dialogModal/getDataNotif'].open;
        this.open = open;
      return 
      },
      // set() {
      //   return this.$store.getters['dialogModal/getDataNotif'].open;
      // },
    },
    title() {
      return this.$store.getters['dialogModal/getDataNotif'].title;
    },
    message() {
      return this.$store.getters['dialogModal/getDataNotif'].message;
    }
  },
    data() {
      return {
        name: "ModalNotif",
        open: false
      };
    },
    methods: {
      notification() {
        this.callNotif();
      }
    }
  
}
</script>

<style lang="sass" scoped>
.headline 
  text-align: center
  justify-content: center
.center
  text-align: center
</style>
